module.exports = __webpack_public_path__ + "img/defaultVoucherIco.d2721bf8.png";